// male https://github.com/cjbarnaby/healthsense-api/blob/master/spec/data/male-valid.json
// const maleValid = {
//   sex: 'male',
//   gender: 'male',
//   about: {
//     dob: '1982-08-17',
//     state: 'New South Wales',
//     occupation: 'developer',
//     atsi: 'yes'
//   },
//   health: {
//     weight: '74.5kg',
//     height: '180cm',
//     smokingStatus: 'yes',
//     lastVisitToDoctor: '12 to 24 months',
//     heartHealthMedication: 'cholesterol',
//     history: {
//       bowelCancerOrPolyps: 'personal',
//       skinCancer: 'none',
//       heartDisease: 'unsure',
//       diabetes: 'none'
//     },
//     lastTest: {
//       bowelCancerHomeScreen: 'less than 12 months',
//       heartHealthCheck: 'never',
//       skinCheckByGP: 'never'
//     }
//   }
// }

// female https://github.com/cjbarnaby/healthsense-api/blob/master/spec/data/female-valid.json
// const femaleValid = {
//   sex: 'female',
//   gender: 'female',
//   about: {
//     dob: '1984-12-04',
//     state: 'Tasmania',
//     occupation: 'writer',
//     atsi: 'no'
//   },
//   health: {
//     weight: '60kg',
//     height: '170cm',
//     smokingStatus: 'no',
//     lastVisitToDoctor: 'less than 12 months',
//     heartHealthMedication: 'no',
//     history: {
//       bowelCancerOrPolyps: 'none',
//       skinCancer: 'family',
//       heartDisease: 'family',
//       diabetes: 'unsure',
//       breastCancer: 'personal'
//     },
//     lastTest: {
//       bowelCancerHomeScreen: 'never',
//       heartHealthCheck: 'more than 24 months',
//       skinCheckByGP: 'less than 12 months',
//       breastCancerScreen: 'never'
//     }
//   }
// }

// The purpose of this function is to return non-flat data structure
// That our API receives

const getFormattedData = (questions, isFemale, voucher) => {
  const { demographic, health } = questions
  const { sex, gender, dob, state, occupation, atsi } = demographic

  const {
    heightWeight,
    smokingStatus,
    lastVisitToDoctor,
    heartHealthMedication,
    bowelCancerOrPolyps,
    skinCancer,
    heartDisease,
    diabetes,
    breastCancer,
    bowelCancerHomeScreen,
    heartHealthCheck,
    skinCheckByGP,
    breastCancerScreen
  } = health

  const { height, weight } = heightWeight

  const result = {
    phaseOneEligible: voucher,
    sex,
    gender,
    about: {
      dob,
      state,
      occupation,
      atsi
    },
    health: {
      weight,
      height,
      smokingStatus,
      lastVisitToDoctor,
      heartHealthMedication,
      history: {
        bowelCancerOrPolyps,
        skinCancer,
        heartDisease,
        diabetes
      },
      lastTest: {
        bowelCancerHomeScreen,
        heartHealthCheck,
        skinCheckByGP
      }
    }
  }

  if (isFemale) {
    result.health.history.breastCancer = breastCancer
    result.health.lastTest.breastCancerScreen = breastCancerScreen
  }

  return result
}

export default getFormattedData
